import { faArrowLeft, faBars, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { saveActu } from "../../actions/actus";
import { connect } from "react-redux";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";
import { tempAlWait } from "../../helpers";
import EditorActu from "../../components/editor/EditorActu";
import { ThemeProvider } from "@emotion/react";
import theme from "../../theme";
import { CssBaseline, Grid, Typography } from "@mui/material";

class AdminActuAdd extends React.Component {
    state = {
        menuActive: false,
        opts: [
            {
                type: 'link',
                ttl: "Retourner à la liste des actualités",
                ico: faArrowLeft,
                link: "/admin/actus",
                action: null,
                col: null
            }
        ],
        form: {
            title: '',
            desc: '',
            codeYtb: '',
            duree: '',
            contenu: ''
        },
        alert: {
            active: false,
            type: '',
            title: "",
            desc: ""
        }
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redSetActu != this.props.redSetActu) {
            this.setState({
                alert: this.props.redSetActu.alert
            })
        }
    }

    handleSave(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        })
        this.props.saveActu({
            title: this.state.form.title,
            desc: this.state.form.desc,
            codeYtb: this.state.form.codeYtb,
            duree: this.state.form.duree,
            contenu: JSON.stringify(this.state.form.contenu),
            nbVue: 0,
            actuId: null,
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Ajouter une actualité"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Titre **/}
                    <div className="admin__inpgrp" title="Titre de l'actualité" aria-label="Titre de l'actualité">
                        <label htmlFor="actu-title" className="admin__lab">
                            Titre *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Titre"
                            className="admin__input"
                            id="actu-title"
                            value={this.state.form.title}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        title: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Description **/}
                    <div className="admin__inpgrp" title="Description courte de l'actualité" aria-label="Description courte de l'actualité">
                        <label htmlFor="actu-desc" className="admin__lab">
                            Résumé *
                        </label>
                        <textarea
                            required
                            placeholder="Résumé"
                            className="admin__input admin__input--txtarea" 
                            id="actu-desc"
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        desc: el.target.value
                                    }
                                }))
                            }}
                            value={this.state.form.desc}></textarea>
                    </div>

                    {/** Code Youtube **/}
                    <div className="admin__inpgrp" title="Code Youtube" aria-label="Code Youtube">
                        <label htmlFor="actu-codeytb" className="admin__lab">
                            Code Youtube *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="XXXXXXXXXXX"
                            className="admin__input"
                            id="actu-codeytb"
                            value={this.state.form.codeYtb}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        codeYtb: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Durée **/}
                    <div className="admin__inpgrp" title="Durée de lecture" aria-label="Durée de lecture">
                        <label htmlFor="actu-duree" className="admin__lab">
                            Durée de lecture
                        </label>
                        <input
                            type="text"
                            placeholder="5 min"
                            className="admin__input"
                            id="actu-duree"
                            value={this.state.form.duree}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        duree: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Contenu **/}
                    <div className="admin__inpgrp" title="Contenu" aria-label="Contenu">
                        <label htmlFor="actu-contenu" className="admin__lab">
                            Contenu
                        </label>
                        <div className="admin__txtlib">
                            <ThemeProvider theme={theme}>
                                <CssBaseline />
                                <Grid container sx={{minHeight: "300px"}} flexDirection={"column"}>
                                    <Grid item xs={9}>
                                        <EditorActu
                                            handleChange={(el) => {
                                                this.setState(prevState => ({
                                                    form: {
                                                        ...prevState.form,
                                                        contenu: el,
                                                    }
                                                }))
                                            }}
                                            value={this.state.form.contenu}
                                        />
                                    </Grid>
                                </Grid>
                            </ThemeProvider>
                        </div>
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Enregistrer l'actualité"
                        aria-label="Enregistrer l'actualité"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSave(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Enregistrer</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redSetActu: state.redSetActu,
    }
}

const mapDispatchToProps = {
    saveActu
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminActuAdd);